import { render, staticRenderFns } from "./TechnicalDrawingsView.vue?vue&type=template&id=19bad9bc"
import script from "./TechnicalDrawingsView.vue?vue&type=script&lang=ts"
export * from "./TechnicalDrawingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports